import React from 'react'

const CountryNames = (props) => {
    return (
        
        <h3>High Score: {props.name} </h3>
    
    )
}

export default CountryNames
